import Vue from 'vue'
import 'jquery'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import echarts from 'echarts'
import AxiosPlugin from '@/utils/plugin/axios-plugin'
import 'font-awesome/css/font-awesome.min.css'
import i18n from "@/assets/languages/index"

Vue.use(ElementUI,{
  i18n: (key, value) => i18n.t(key, value)
})
Vue.use(echarts)
Vue.config.productionTip = false
Vue.prototype.$echarts = echarts
Vue.use(AxiosPlugin)


new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')

import navbar from '../src/components/content/maintabber/nav_tabar'
Vue.component("nav-bar",navbar)
